import { render, staticRenderFns } from "./QuizThumbnail.vue?vue&type=template&id=13db34be"
import script from "./QuizThumbnail.vue?vue&type=script&lang=js"
export * from "./QuizThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports